import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DangerIcon from '../../../dist/icons/DangerIcon';
import { createClient } from '../../../features/payement/payementSlice';
import { getPays } from '../../../features/pays/paysSlice';
import { links } from '../../../utils/constants';
import FormBtnLarge from '../../components/button/FormBtnLarge';
import AuthSelectField from '../../components/textfield/AuthSelectField';
import AuthTexfield from '../../components/textfield/AuthTexfield';
import Layout from '../../layout/Layout';

const InfoPage = () => {
    const [email, setEmail] = useState("");
    const [telephone, setTelephone] = useState("");
    const [payss, setPayss] = useState("");
    const [btnm, setBtnm] = useState('Continuer');
    const [disable, setDisable] = useState(false);
    const [errors, setErrors] = useState("");
    let navigate = useNavigate()
    const dispatch = useDispatch()
    const { pays } = useSelector(
        (state) => state.pays
    )
    const { client, isClientSuccess } = useSelector(
        (state) => state.payement
    )
    const handleCreate = (e) => {
        e.preventDefault()
        if(email && telephone && payss){
            setDisable(true)
            setBtnm('Traitement en cours...')
            const data = {
                email,
                telephone,
                payss
            }
            dispatch(createClient(data))
        }else{
            setErrors("Veuillez remplir tous les champs")
        }
    }

   useEffect(() => {
    dispatch(getPays())
    if(isClientSuccess){
        setDisable(false)
        setBtnm('Continuer')
        if(client){
            navigate(links.modepaiement, {
                state: {
                    pays: payss,
                    client: client.id
                }
            })
        }
    }
   }, [dispatch, isClientSuccess, client, payss, navigate])
   

    return (
        
        <Layout>
            {
                pays ? (
                    <>
                    <div className='ipay-ui-page__title'>
                        <h1>Bienvenue sur IventPay</h1>
                        <span>Veuillez insérer ces informations pour pouvoir continuer</span>
                    </div>
                    <div className='ipay-ui-page__container'>
                        <form className='ipay-ui-page__form' onSubmit={handleCreate}>
                            {
                                (errors) && (
                                    <div className='ipay-ui-modal__alert is--error'>
                                        <div className='ipay-ui-modal__alert--icon'>
                                            <DangerIcon/>
                                        </div>
                                        <div className='ipay-ui-modal__alert--text'>
                                            <p>
                                                {errors}
                                            </p>
                                        </div>
                                    </div>
                                ) 
                            }
                            <div className='ipay-ui-page__form-group'>
                                <div>
                                    <AuthTexfield label={'Email'} name={'email'} type={'email'} fnc={setEmail}>
                                        {'Veuillez entrer votre email'}
                                    </AuthTexfield> 
                                </div>
                                <div>
                                    <AuthTexfield label={'Téléphone'} name={'telephone'} type={'text'} fnc={setTelephone}>
                                        {'Veuillez entrer votre numéro de télephone'}
                                    </AuthTexfield> 
                                </div>
                                <div>
                                    <AuthSelectField label={'Pays de résidence'} name={'pays'} tabs={pays} fnc={setPayss}>
                                    {'Veuillez choisir votre pays de résidence'}
                                    </AuthSelectField>
                                </div>
                            </div>
        
                            <div className='ipay-ui-otherlayout-form__action'>
                                <FormBtnLarge type={'submit'} mStyle={'is--primary'} disable={disable}>
                                    {btnm}
                                </FormBtnLarge>
                            </div>
                        </form>
                    </div>
                    </>
                ) : (
                    "Chargement en cours.."
                )
            }
        </Layout>
    );
};

export default InfoPage;